import { render } from "./RecordDialog.vue?vue&type=template&id=e6c25eca&scoped=true"
import script from "./RecordDialog.vue?vue&type=script&lang=js"
export * from "./RecordDialog.vue?vue&type=script&lang=js"

import "./RecordDialog.vue?vue&type=style&index=0&id=e6c25eca&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\website-shuziyun\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6c25eca"]])

export default __exports__